import { Link } from "@inertiajs/react";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  OPS_CONSOLE_HREF,
  PLATFORM_CONSOLE_SECTIONS,
  SUPPORT_CONSOLE_HREF,
  type PlatformConsoleSectionKey,
} from "@/lib/platformConsoleNav";

function isInertiaPageHref(href: string): boolean {
  return href.startsWith("/madmin") === false;
}

type PlatformConsoleBreadcrumbProps = {
  console?: "ops" | "support";
  section?: PlatformConsoleSectionKey;
  current: string;
  className?: string;
};

export function PlatformConsoleBreadcrumb({
  console = "ops",
  section,
  current,
  className,
}: PlatformConsoleBreadcrumbProps) {
  const consoleHref = console === "ops" ? OPS_CONSOLE_HREF : SUPPORT_CONSOLE_HREF;
  const consoleLabel = console === "ops" ? "Ops Console" : "Support Console";
  const sectionConfig = section ? PLATFORM_CONSOLE_SECTIONS[section] : null;

  return (
    <nav aria-label="Breadcrumb" className={cn("mb-4", className)}>
      <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
        <li>
          <a href={consoleHref} className="hover:text-foreground transition-colors">
            {consoleLabel}
          </a>
        </li>
        {sectionConfig && (
          <li className="flex items-center gap-1">
            <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden />
            {isInertiaPageHref(sectionConfig.href) ? (
              <Link href={sectionConfig.href} className="hover:text-foreground transition-colors">
                {sectionConfig.label}
              </Link>
            ) : (
              <a href={sectionConfig.href} className="hover:text-foreground transition-colors">
                {sectionConfig.label}
              </a>
            )}
          </li>
        )}
        <li className="flex items-center gap-1">
          <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span className="font-medium text-foreground" aria-current="page">
            {current}
          </span>
        </li>
      </ol>
    </nav>
  );
}
